import { styled, alpha } from '@mui/material/styles';
import { paddingCardsTables } from '../../commons';

export const SinDatos = () => {
  const Div = styled('div')(({ theme }) => ({
    ...theme.typography.button,
    backgroundColor: 'wheat',
    padding: theme.spacing(8),
    textAlign: 'center',
    width: '100%',
  }));

  return (
    <>
      <Div>{'No hay datos disponibles...'}</Div>
    </>
  );
};
